import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  PlatformConnectionModalStyled,
  PlatformConnectionModalDescription,
} from 'Features/platformConnectionModal/PlatformConnectionModal.styled'
import { OptionSelector, ModalControlsStyled, Button } from '@clickcease/cc-client-components-lib'
import { useAppStore } from 'Stores/appStoreModuleFed'
import {
  platformConnectionModalOptions,
  PlatformsLookupArr,
} from './PlatformConnectionModalOptions'
import { GOOGLE } from '../../enums/platforms'

type PlatformConnectionModalProps = {
  onOpenChange: (a: boolean) => void
}

export const PlatformConnectionInner = ({ onOpenChange }: PlatformConnectionModalProps) => {
  const { t } = useTranslation('domainManagement')
  const [selectedPlatform, setSelectedPlatform] = useState<number>(1)
  const { setPmPlatformConnectionModal } = useAppStore()

  const openPlatformWizard = () => {
    onOpenChange(false)
    setPmPlatformConnectionModal(true, PlatformsLookupArr[selectedPlatform - 1] || GOOGLE)
  }

  return (
    <PlatformConnectionModalStyled id={'platform-connection-modal'}>
      <PlatformConnectionModalDescription>
        {t('platformConnectionModal.description')}
      </PlatformConnectionModalDescription>
      <OptionSelector
        options={platformConnectionModalOptions}
        selectedPlatform={selectedPlatform}
        setSelectedPlatform={(option) => {
          setSelectedPlatform(option)
        }}
      />
      <ModalControlsStyled>
        <Button
          variant="ghost"
          text={t('platformConnectionModal.cancel')}
          onClick={() => {
            onOpenChange(false)
          }}
        />
        <Button
          css={{ width: '81px' }}
          text={t('platformConnectionModal.next')}
          onClick={() => {
            openPlatformWizard()
          }}
        />
      </ModalControlsStyled>
    </PlatformConnectionModalStyled>
  )
}
